<template>
  <v-row>
    <v-col>
      <v-card-text>
        <ValidationObserver
          ref="observer"
          v-slot="{ valid }"
        >
          <v-row>
            <!-- <v-col
              sm="12"
              md="3"
            >
              <render-input
                :input="fieldConfig.customer"
                v-model="model.customer"
                :disabled="loading"
              ></render-input>
            </v-col> -->
            <v-col
              sm="12"
              md="6"
            >
              <render-input
                :input="fieldConfig.branch"
                v-model="model.branch"
                :disabled="loading"
              ></render-input>
            </v-col>
            <v-col
              sm="12"
              md="3"
            >
              <render-input
                :input="fieldConfig.lotNumber"
                v-model="model.lotNumber"
                :disabled="loading"
              ></render-input>
            </v-col>
            <v-col
              sm="12"
              md="3"
            >
              <render-input
                :input="fieldConfig.lotNumberDesc"
                v-model="model.lotNumberDesc"
                :disabled="loading"
              ></render-input>
            </v-col>
            <v-col
              sm="12"
              md="5"
            >
              <custom-uploadfile
                ref="fileInput"
                @change="handleFile"
                :disabled="!valid || loading"
              ></custom-uploadfile>

            </v-col>

            <v-col>
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="blue-grey"
              ></v-progress-circular>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <!-- โน้ตเพิ่มเติม -->
              <v-alert
                type="info"
                dense
                text
                class="mt-2"
              >
                *อ่านข้อมูลจากชีทแรกเท่านั้น<br>
                **เริ่มอ่านข้อมูลจากแถวที่ 3
              </v-alert>
            </v-col>
          </v-row>

          <v-row class="ml-2">
            <v-simple-table
              class="custom-table"
              dense
            >
              <thead>
                <tr>
                  <th class="text-center">ลูกค้า</th>
                  <th class="text-center">ดาวน์โหลด</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(mapping,index) in mappings"
                  :key="index"
                  class="row-item"
                >
                  <td>{{ mapping.customer.text }}</td>
                  <td class="text-center">
                    <v-btn
                      @click="generateTextFile(mapping.filename, mapping.content)"
                      small
                      color="primary"
                      depressed
                    >
                      <v-icon
                        left
                        small
                      >mdi-download</v-icon>
                      Download
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-row>

        </ValidationObserver>

      </v-card-text>
    </v-col>
  </v-row>
</template>

<script>
import { getBranches, getCustomers } from "./../../js/dropdown-service";
import { InputType } from "./../../js/constants";

import { fakeAbbr, getFakeUrl } from "./../../_helpers/fake-url";
import CustomUpLoadFile from "./../../components/custom/custom-uploadfile";
import { getToken } from "../../js/authorization";
import { generateTextFile } from "../../js/custom";

export default {
  data() {
    return {
      model: {
        // customer: null,
        branch: null,
        lotNumber: null,
        lotNumberDesc: null,
      },
      mappings: [],
      loading: false,
    };
  },
  components: {
    "custom-uploadfile": CustomUpLoadFile,
  },
  created() {
    this.getMappings();
  },
  methods: {
    async handleFile(file) {
      this.$refs.fileInput.clearFile();
      if (!(file && file.length > 0)) {
        return;
      }

      let valid = await this.$refs.observer.validate();
      if (!valid) {
        return;
      }

      var data = new FormData();
      data.append("file", file[0]);
      // data.append("customerId", this.model.customer.id);
      data.append("branch", this.model.branch.id);
      data.append("lotNumber", this.model.lotNumber);
      data.append("lotNumberDesc", this.model.lotNumberDesc);

      // console.log(data);

      let url = "/case/uploadFile";
      this.loading = true;
      this.$http
        .uploadFile(url, data)
        .then((res) => {
          this.showAlertSuccess("อัพโหลดข้อมูลสำเร็จ");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getMappings() {
      let url = "/case/UploadMappingField";
      this.$http.get(url).then((res) => {
        res.items.forEach((item) => {
          let obj = item;
          obj.filename = `PGP ${item.customer.text}`;
          obj.content = this.generateContentTextFile(item);
          this.mappings.push(obj);
        });
      });
    },
    col(num) {
      let s = "";
      while (num > 0) {
        let m = (num - 1) % 26;
        s = String.fromCharCode(65 + m) + s;
        num = Math.floor((num - 1) / 26);
      }
      return s;
    },
    generateContentTextFile(obj) {
      let text = "";
      let lines = [];
      lines.push(`ลูกค้า: ${obj.customer.text}`);
      lines.push(`ชีท: ชีทแรกเท่านั้น`);
      lines.push(`เริ่มอ่านข้อมูลจากแถวที่: 3`);
      lines.push("");
      obj.items.forEach((item) => {
        let tmp = `${this.col(item.index)}(${item.index}) = ${item.desc}`;
        lines.push(tmp);
      });
      lines.push(
        "------------------------------------------------------------------\r\n"
      );
      text += lines.join("\r\n");

      return text;
    },
    generateTextFile(filename, content) {
      var atag = document.createElement("a");
      var file = new Blob([content], { type: "text/plain" });
      atag.href = URL.createObjectURL(file);
      atag.download = filename;
      atag.click();
    },
  },
  computed: {
    fieldConfig() {
      return {
        // customer: {
        //   name: "customer",
        //   text: "ลูกค้า",
        //   type: InputType.dropdown,
        //   data: {
        //     promise: getCustomers(),
        //   },
        //   rule: {
        //     required: true,
        //   },
        // },
        branch: {
          name: "branch",
          text: "OA",
          type: InputType.dropdown,
          data: {
            promise: getBranches({ authorize: true, useShortName: true }),
          },
          rule: {
            required: true,
          },
        },
        lotNumber: {
          name: "lotNumber",
          text: "Lot Date",
          type: InputType.monthPicker,
          rule: {
            required: true,
          },
        },
        lotNumberDesc: {
          name: "lotNumberDesc",
          text: "รายละเอียด",
          type: InputType.text,
          rule: {
            required: true,
            min: 1,
            max: 3,
          },
        },
      };
    },
  },
};
</script>

<style scoped>
.v-card__text {
  height: 600px;
}

.custom-table {
  border-radius: 8px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
}

.custom-table td,
.custom-table th {
  width: 200px; /* ปรับขนาดตามต้องการ */
  min-width: 200px;
  max-width: 200px;
}

.custom-table thead {
  background: #eceff1;
}

.custom-table th {
  padding: 6px 10px !important;
  font-weight: 600;
  color: #37474f;
  font-size: 0.8rem;
}

.custom-table td {
  padding: 6px 10px !important;
  font-size: 0.8rem;
  color: #424242;
}

.row-item:hover {
  background: #f5f5f5;
  transition: background 0.2s;
}

.v-btn {
  min-width: 60px !important;
  font-size: 0.75rem !important;
}
</style>